<template>
  <div class="error" transition="fade">
    {{ error }}
  </div>
</template>
<script>
export default {
  name: "Error",

  props: {
    error: {
      type: String,
      required: true
    }
  }
};
</script>
